import { FC, useState } from 'react';
import styles from './Document.module.css';
import { Search, X } from 'lucide-react';
import { Input } from '../ui/input';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { containerDivFadeIn } from '@/constants/variants';
import useDebounce from '@/lib/hooks/useDebounce';
import CategoryDropdown from '../CategoryDropdown/CategoryDropdown';

interface DocumentHeaderProps {
	selectedCategory: string;
	setSelectedCategory: (selectedCategory: string) => void;
	handleSearchChange: (searchTerm: string) => void;
}

const DocumentHeader: FC<DocumentHeaderProps> = ({
	selectedCategory,
	setSelectedCategory,
	handleSearchChange,
}) => {
	const [searchTerm, setSearchTerm] = useState<string>('');
	const debouncedSearchChange = useDebounce(handleSearchChange, 600);

	return (
		<div className="z-20 px-8 pt-5">
			<motion.div
				className={cn(
					styles.header,
					'px-5 py-4 flex justify-between items-center '
				)}
				key="containerDivFadeIn"
				variants={containerDivFadeIn}
				initial="initial"
				animate="animate"
			>
				<div className="flex items-center justify-start">
					<p className="font-bold text-secondary dynamic-xl-large">Documents</p>
				</div>
				<div className="flex justify-end gap-4">
					<CategoryDropdown
						className="h-11 w-52 dynamic-small border border-primary px-3 hover:bg-[#EAF1FC] disabled:bg-[#F5F5F5]"
						showAll={true}
						selectedCategory={selectedCategory}
						setSelectedCategory={setSelectedCategory}
					/>
					<div className="relative">
						<Input
							value={searchTerm}
							onChange={(event) => {
								setSearchTerm(event.target.value);
								debouncedSearchChange(event.target.value);
							}}
							placeholder="Search for your document"
							className="bg-white border-[#D3DDE2] w-72 h-11 p-4 dynamic-small rounded-xl hover:bg-[#EAF1FC] disabled:bg-[#F5F5F5] pr-12"
						/>
						<div className="absolute right-8 top-3.5">
							{searchTerm !== '' && (
								<X
									onClick={() => {
										setSearchTerm('');
										debouncedSearchChange('');
									}}
									className="cursor-pointer"
									color="#5D6F79"
									size={16}
								/>
							)}
						</div>
						<div className="absolute right-3 top-3.5">
							<Search color="#5D9BFD" size={16} />
						</div>
					</div>
				</div>
			</motion.div>
		</div>
	);
};

export default DocumentHeader;
